import { type ReactNode, createContext, useContext } from 'react';

export type TransactionFormUiVariant = 'default' | 'onboarding';

const TransactionFormUiContext =
  createContext<TransactionFormUiVariant>('default');

export const TransactionFormUiProvider = ({
  variant,
  children,
}: {
  variant: TransactionFormUiVariant;
  children: ReactNode;
}) => (
  <TransactionFormUiContext.Provider value={variant}>
    {children}
  </TransactionFormUiContext.Provider>
);

export const useTransactionFormUi = (): TransactionFormUiVariant =>
  useContext(TransactionFormUiContext);

export const useTransactionGridSpacing = (): number => {
  const variant = useTransactionFormUi();
  return variant === 'onboarding' ? 1.5 : 2;
};
